import {ModelEvents} from '@denishussar/html5-game-engine';
import {GameModel, GameStateEnum} from '../../Models/GameModel';
import {GameLogic} from '../GameLogic';
import {ModalsManager} from '../../Common/MadalsManager/ModalsManager';
import {ModalsNames} from '../../Common/MadalsManager/ModalsList';
import {BaseBannerLogic} from "../Ads/BaseBannerLogic";
import {ADS_TYPE} from "../../Common/Ads/AdsType";
import {AdsLogic} from "../Ads/AdsLogic";

export class CrazyGamesBannerLogic extends BaseBannerLogic {
    constructor(private modelEvents: ModelEvents,
                private model: GameModel,
                private adsLogic: AdsLogic,
                private gameLogic: GameLogic,
                private modalsManager: ModalsManager,
    ) {
        super();

        this.modelEvents.on(this.model, 'changeModal', (state: string, key: string) => {
            if (!this.adsLogic.isReady) return;
            if (state === 'show' && key === ModalsNames.shopCrazyGames) {
                this.adsLogic.adsLogic.clearAllBanners();

            } else if (state === 'hide' && key === ModalsNames.shopCrazyGames) {
                // this.crazyGamesAdsLogic.requestAd(CrazyGamesAdsType.banner_320x50);
            }
        }, this);

        this.modelEvents.on(this.model, 'setState', async (state: GameStateEnum) => {
            if (!this.adsLogic.isReady) return;
            switch (state) {
                case GameStateEnum.catalog:
                    //this.crazyGamesAdsLogic.requestAd(CrazyGamesAdsType.banner_320x50);
                    break;

                case GameStateEnum.game:
                    this.adsLogic.adsLogic.clearAllBanners();

                    setTimeout(async () => {
                        if (!this.model.isSetPictureForAds && (window['current_social'] !== 'azerion' && !this.gameLogic.isFTUE)) {
                            this.model.soundOff = true;
                            await this.adsLogic.adsLogic.requestAd(ADS_TYPE.INTERSTITIAL)
                                .finally(() => {
                                    this.model.soundOff = false;
                                })
                        }

                        if (!this.gameLogic.isFTUE) {
                            // this.crazyGamesAdsLogic.requestAd(CrazyGamesAdsType.banner_320x50);
                        }
                    }, 500);
                    break;

                case GameStateEnum.main:
                    if (this.model.gameState === GameStateEnum.game) {
                        this.adsLogic.adsLogic.clearAllBanners();

                        if (this.model.picture.name !== 'FTUE') {
                            //setTimeout(() => this.adsLogic.adsLogic.requestAd(ADS_TYPE.INTERSTITIAL), 500);
                        }
                    } else if (this.model.gameState === GameStateEnum.win) {
                        this.adsLogic.adsLogic.clearAllBanners();
                        // setTimeout(() => this.adsLogic.adsLogic.requestAd(ADS_TYPE.INTERSTITIAL), 500);
                    }
                    break;


                case GameStateEnum.win:
                    if (this.model.gameState === GameStateEnum.game) {
                        this.adsLogic.adsLogic.clearAllBanners();

                        if (this.model.picture.name !== 'FTUE') {
                            this.model.soundOff = true;
                            setTimeout(async () => await this.adsLogic.adsLogic.requestAd(ADS_TYPE.INTERSTITIAL)
                                .finally(() => {
                                    this.model.soundOff = false;
                                }), 500);
                        }
                    }
                    break;

                default:
                    this.adsLogic.adsLogic.clearAllBanners();
            }
        }, this);
    }
}
